import React from 'react';
import { Icon } from './Icon.js';
export const IconCirclePlayFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,0C2.691,0,0,2.691,0,6s2.691,6,6,6,6-2.691,6-6S9.309,0,6,0Zm1.724,6.518l-2.308,1.385c-.403.242-.916-.048-.916-.518v-2.771c0-.47.513-.76.916-.518l2.308,1.385c.391.235.391.802,0,1.037Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCirclePlayFill12.js.map